import ReasonForVisit from './layouts/ReasonForVisit';

export const questionLayouts = {
  ReasonForVisit
}